import {
  IDataMinerIncentiveItem,
  IDataMinerIncentiveMatchRequest,
  IDataMinerPropertyLookupRequest,
  IDataMinerPropertyLookupResponse,
} from "../contracts/DataMiner";
import { IZeosApiResponse } from "../contracts/ZeosApi";
import { getDataAsync, postDataAsync } from "../ZeosApiExecutor";
import { IDataMiner } from "./interfaces/IDataMiner";

const API_BASE = "/DataMiner";

const buildQueryString = (request: IDataMinerPropertyLookupRequest) => {
  const params = new URLSearchParams();
  if (request.address) params.set("address", request.address);
  if (request.apn) params.set("apn", request.apn);
  if (request.buildingKey) params.set("buildingKey", request.buildingKey);
  if (request.zip) params.set("zip", request.zip);
  if (request.useLiveLookup) params.set("useLiveLookup", "true");
  const qs = params.toString();
  return qs ? `?${qs}` : "";
};

export const DataMiner: IDataMiner = {
  getAllIncentives: async (): Promise<IZeosApiResponse<IDataMinerIncentiveItem[]>> => {
    const response = await getDataAsync<IDataMinerIncentiveItem[]>(
      `${API_BASE}/Incentives/All`,
      ""
    );
    return response;
  },
  matchIncentives: async (
    request: IDataMinerIncentiveMatchRequest
  ): Promise<IZeosApiResponse<IDataMinerIncentiveItem[]>> => {
    const response = await postDataAsync<IDataMinerIncentiveItem[]>(
      `${API_BASE}/Incentives/Match`,
      request
    );
    return response;
  },
  lookupProperty: async (
    request: IDataMinerPropertyLookupRequest
  ): Promise<IZeosApiResponse<IDataMinerPropertyLookupResponse>> => {
    const qs = buildQueryString(request);
    const response = await getDataAsync<IDataMinerPropertyLookupResponse>(
      `${API_BASE}/PropertyLookup${qs}`,
      ""
    );
    return response;
  },
};
